import {
  InputFacebookLoginData,
  InputGoogleLoginData,
  InputJoinData,
  InputTwitterLoginData,
} from "@scrile/api-provider/dist/api/LoginProvider";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import providers, { getMemoryProviders } from "@/lib/api";
import { getReferral } from "@/lib/referralHelpers";

const sendReferral = (userId: string) =>
  providers.UserReferringProvider.update({
    data: {
      userId: userId,
      referrerId: getReferral(),
    },
  });

export async function loginFacebook(data: InputFacebookLoginData) {
  const response = await providers.LoginProvider.facebookLogin({ data });
  await sendReferral(response.user.id);
  return response;
}

export async function loginTwitter(data: InputTwitterLoginData) {
  const response = await providers.LoginProvider.twitterLogin({ data });
  await sendReferral(response.user.id);
  return response;
}

export async function loginGoogle(data: InputGoogleLoginData) {
  const response = await providers.LoginProvider.googleLogin({ data });
  await sendReferral(response.user.id);
  return response;
}

export async function loginSignUp(data: InputJoinData) {
  const response = await providers.LoginProvider.join({ data });
  await sendReferral(response.user.id);
  return response;
}

export async function loginEmail(email: string, password: string, safe = false) {
  if (safe) {
    const { providers: tempProviders, apiTools } = getMemoryProviders();
    tempProviders.LoginProvider.setReceiveErrors(false);
    await tempProviders.LoginProvider.login({ email, password });
    apiTools.close();
  }

  providers.LoginProvider.setReceiveErrors(false);
  return providers.LoginProvider.login({ email, password });
}

export function loginToken(token: string) {
  return providers.LoginProvider.refreshTokenV2({ token, createNewLongLiveToken: true });
}

export const allowAccess = (user: User | null) =>
  (user && (!!(user as any).phone || (user.emailVerified && !!user.email)) && !user.accountInfo.disabled) || false;

export const archivedUser = (user: User | null) =>
  (user && user.accountInfo.disabled && user.accountInfo.deleteAfter) || false;
